import React, { useState } from "react";
import Divider from "@mui/material/Divider";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";
import CircularProgress from "@mui/material/CircularProgress";
import { useTranslation } from "react-i18next";
import "../../../../Localization/i18n";
import trash from "../../../../icons/trash.svg";
import axios from "../../../../utils/fvAxios";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/material";
import BaseURL from "../../../../utils/base-uri.json";
import Button from "@mui/material/Button";
import { getOrgType } from "../../../../utils/Token";

export default function DangerZone({ userId }) {
  const navigate = useNavigate();

  const [isDeleting, setIsDeleting] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const { t } = useTranslation();

  const confirmDelete = async () => {
    setIsDeleting(true);
    const resp = await axios.post(
      BaseURL.settings.DeleteUser + "?userId=" + userId,
      {}
    );
    if (resp.data?.responseMessage === "Success") {
      setDeleteDialogOpen(false);
      setIsDeleting(false);
      const nav=getOrgType()=="Admin"?"/SearchUser":"/ClientOrVendorUsersList"
      navigate(nav);
    } else {
      console.error(resp?.data?.responseMessage);
    }
  };
  const handleDialogClose = () => {
    setDeleteDialogOpen(false);
  };
  return (
    <>
      <Dialog open={deleteDialogOpen} onClose={handleDialogClose}>
        <DialogTitle id="alert-dialog-title">
          {"Are you sure you want to delete?"}
        </DialogTitle>
        <DialogActions className="w-100 d-flex">
          <Button
            variant="outlined"
            onClick={handleDialogClose}
            style={{ padding: "12px" }}
          >
            Cancel
          </Button>
          {isDeleting ? (
            <Box
              style={{
                display: "flex",
                marginLeft: "auto",
                padding: "5px",
              }}
            >
              <CircularProgress size={28} />
            </Box>
          ) : (
            <Button
              variant="contained"
              onClick={confirmDelete}
              style={{ marginLeft: "auto", padding: "12px" }}
            >
              Yes, delete
            </Button>
          )}
        </DialogActions>
      </Dialog>
      <div className="form">
        <label className="personal-info-heading">
          <b>Danger Zone</b>
        </label>
        <Divider className="mt-3" />
        <div className="row mt-2">
          <div className="col-sm-6 col-md-6 col-xl-6 mt-3">
            <span className="input-label-right">Delete User</span>
          </div>
          <div className="col-sm-4 col-md-4 col-xl-4 mt-1">
            <Button
              variant="outlated"
              color="primary"
              onClick={() => {
                setDeleteDialogOpen(true);
                setIsDeleting(false);
              }}
            >
              <p style={{ color: "red", textTransform: "capitalize" }}>
                <img src={trash} alt="trash icon" /> Delete
              </p>
            </Button>
          </div>
          <div className="col-sm-2 col-md-2 col-xl-2 block"></div>
        </div>
      </div>
    </>
  );
}
